<template>
  <section class="section_platform" ref="trigger">
    <div class="inner">
      <h2>
        <img
          src="~@/assets/images/pc_new/img_platform_tit.svg"
          class="platform_tit"
          alt="쉽게 다 되는 투자 플랫폼"
        />
      </h2>
    </div>
    <div class="platform_container" :class="{ show: platformShow }">
      <!-- show 붙이면 애니메이션 시작 함-->
      <div class="platform_line line01">
        <div class="platform_item item01">
          <img
            src="~@/assets/images/pc_new/platform/img01.png"
            class="platform_img"
            alt="trading 실시간 투자 한국주식, 미국주식, ETF까지 실시간으로 투자하세요."
          />
        </div>
        <div class="platform_item item02">
          <img
            src="~@/assets/images/pc_new/platform/img05.png"
            class="platform_img"
            alt="investment 테마 투자 초보자도 쉽게 투자멘토가 되어드릴게요."
          />
        </div>
        <div class="platform_item item03">
          <img
            src="~@/assets/images/pc_new/platform/img10.png"
            class="platform_img"
            alt="community 미니톡 내 주식에 무슨일이? 미니톡에서 확인하세요."
          />
        </div>
      </div>
      <div class="platform_line line02">
        <div class="platform_item item04">
          <img
            src="~@/assets/images/pc_new/platform/img02.png"
            class="platform_img"
            alt="investment 소수점 투자 1,000원부터 해외주식에 투자할 수 있어요."
          />
        </div>
        <div class="platform_item item05">
          <img
            src="~@/assets/images/pc_new/platform/img04.png"
            class="platform_img"
            alt="investment 배당주 투자 계좌속 깜짝선물 배당주, 배당금 확인도 쉽고 빨라요."
          />
        </div>

        <!-- 2025-12-24 수정 -->
        <div class="platform_item item06">
          <img
            src="~@/assets/images/pc_new/platform/img08.png"
            class="platform_img"
            alt="margin 신용/대출 자금이 부족한 순간 간편, 신속하게!"
          />
        </div>
        <!-- <div class="platform_item item06" @click="link()">
          <img
            src="~@/assets/images/pc_new/platform/img07.png"
            class="platform_img"
            alt="event 막주는 혜택 랜덤주식증정, 무료 수수료"
          />
        </div> -->
        <!-- // 2025-12-24 수정 -->

      </div>
      <div class="platform_line line03">
        <div class="platform_item item07">
          <img
            src="~@/assets/images/pc_new/platform/img03.png"
            class="platform_img"
            alt="investment 자동투자 설정 한번에 알아서 척척 마음 편하게 투자할 수 있어요."
          />
        </div>
        <div class="platform_item item08">
          <img
            src="~@/assets/images/pc_new/platform/img09.png"
            class="platform_img"
            alt="community 수익률 공유하기 내 수익률 올라도, 떨어져도 힙하게 공유하는 센스"
          />
        </div>

        <!-- <div class="platform_item item09">
          <img
            src="~@/assets/images/pc_new/platform/img08.png"
            class="platform_img"
            alt="margin 신용/대출 자금이 부족한 순간 간편, 신속하게!"
          />
        </div> 2025-12-24 이미지 위치 이동 -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      platformShow: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollLocation = document.documentElement.scrollTop; // 현재 스크롤바 위치
      if (scrollLocation > 8368 && scrollLocation < 11819) {
        this.platformShow = true;
      } else {
        this.platformShow = false;
      }
    });
  },
  methods: {
    link() {
      if (IS_MOBILE.any()) {
        location.href =
          "https://mini.koreainvestment.com/stock/event/index1.html";
      } else {
        window.open("https://mini.koreainvestment.com/stock/event/index1.html");
      }
    },
  },
};

var IS_MOBILE = {
  isAndroid: function() {
    return navigator.userAgent.match(/Android/i);
  },
  isBlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  isIOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  isOpera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  isWindows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (
      IS_MOBILE.isAndroid() ||
      IS_MOBILE.isBlackBerry() ||
      IS_MOBILE.isIOS() ||
      IS_MOBILE.isOpera() ||
      IS_MOBILE.isWindows()
    );
  },
};
</script>
